import './menu-style.scss';

document.addEventListener( 'DOMContentLoaded', init );
function init() {

    const siteMenuInner         = document.querySelector( '.site-menu > div');
    const menuGroup             = document.querySelector( '.section-site-menu' );
    const siteMenu              = document.querySelector( '.site-menu' );
    const subMenuGroup          = document.querySelector( '.section-sub-menu' );
    //const sectionCategoryMenu   = document.querySelector( '.section-category-menu' );
    //const sectionCatSubMenus    = document.querySelector( '.category-menu-sub-menus' );
    const backButtonSection     = document.querySelector( '.mobile-menu-back' );
    const menuClose             = document.querySelector('.site-menu-close');
    const menuOpen              = document.querySelector('.site-menu-open');

    const siteHeaderGroup       = document.querySelector('.site-header-group');
    const mobileMenuOpen        = document.querySelector('.mobile-menu-trigger');

    mobileMenuOpen.addEventListener('click', function(){
        siteHeaderGroup.classList.toggle('active');
        document.body.classList.toggle('mobile-menu-active');
    });

    //const mobileDropDowns = document.querySelectorAll('.has-dropdown');
    siteHeaderGroup.addEventListener('click', dropDownAction);
    function dropDownAction(event) {

        if ( window.innerWidth > 900 ) {
            return false;
        }

        if ( event.target.classList.contains('has-dropdown') ) {

            const dropDownNavs = document.querySelectorAll('.site-menu > .wp-block-group');
            [...dropDownNavs].forEach( nav => {
                nav.classList.remove('active');
            });

            const parent = event.target.closest('.wp-block-group');
            parent.classList.add('active');
        }
    }

    // const backButtonTrigger     = document.querySelector( '.mobile-menu-back a' );
    // backButtonTrigger.dataset.menuTarget = '';
    // backButtonTrigger.addEventListener( 'click', moveMenuBack );

    siteMenu.addEventListener( 'click', siteMenuAction );
    siteMenuInner.addEventListener( 'mouseleave', resetMenu );

    // menuOpen.addEventListener( 'click', function() {
    //     menuGroup.classList.add('mobile-active');
    //     document.body.classList.add('mobile-menu-open');
    // });

    // menuClose.addEventListener( 'click', function() {
    //     menuGroup.classList.remove('mobile-active');
    //     document.body.classList.remove('mobile-menu-open');
    // });

    function moveMenuBack(event) {

        const target = event.target.dataset.menuTarget;

        if ( target === 'sub' ) {

            // sectionCatSubMenus.classList.remove('open');
            // allSubMenus = sectionCatSubMenus.querySelectorAll('.open');
            // [...allSubMenus].forEach( subMenu => {
            //     subMenu.classList.remove('open');
            // });

            // catHeading.innerText = '';
            // subCatHeading.innerText = '';
            event.target.dataset.menuTarget = '';
        }

        if ( target === 'subsub' ) {
            // sectionCatSubMenus.classList.remove('open');
            // allSubMenus = sectionCatSubMenus.querySelectorAll('.open');
            // [...allSubMenus].forEach( subMenu => {
            //     subMenu.classList.remove('open');
            // });

            // subCatHeading.innerText = '';
            // event.target.dataset.menuTarget = 'sub';
        }

        if ( target === '' ) {
            const all = document.querySelectorAll('.section-site-menu .open');
            [...all].forEach( open => {
                open.classList.remove('open');
            });

            backButtonSection.classList.add('hide');
        }

        // const menuToClose = document.querySelector(target);
        // menuToClose.classList.remove('open');
    }

    function siteMenuAction(event) {
        console.log( 'site menu' );
        if ( ! event.target.classList.contains('menu-item') ) {
            return false;
        }

        //backButtonSection.classList.remove('hide');

        document.documentElement.style.setProperty('--menuPosition', 0 + '%');

        const theSubMenuSelector    = event.target.classList[2].split('menu-item-');
        const theSubMenuClass       = `.sub-menu-${theSubMenuSelector[1]}`;
        const theSubMenu            = subMenuGroup.querySelector(theSubMenuClass);

        console.log(theSubMenu);

        // const menuItemPosCenter       = ( event.target.getBoundingClientRect().left + event.target.getBoundingClientRect().right ) / 2;
        // const theSubMenuPostCenter    = ( theSubMenu.getBoundingClientRect().left + theSubMenu.getBoundingClientRect().right ) / 2;
        // const windowWidth           = window.innerWidth;
        // const translatePerc         = ( menuItemPosCenter - theSubMenuPostCenter ) / 2;

        //document.documentElement.style.setProperty('--menuPosition', translatePerc + 'px');

        console.log( theSubMenu);
        toggleMenu( event.target, theSubMenu );
    }

    function toggleMenu(menuItem, theSubMenu) {

        const allMainMenuItems = siteMenu.querySelectorAll('.menu-item');
        [...allMainMenuItems].forEach( item => {
            item.classList.remove('open');
        });

        const allSubMainMenus = subMenuGroup.querySelectorAll('.sub-menu');
        [...allSubMainMenus].forEach( item => {
            item.classList.remove('open');
        });

        openSubMenu(menuItem, theSubMenu);
    }

    function resetMenu(event) {

        if ( window.outerWidth < 1000 || window.innerWidth > 1000 ) {
            return false;
        }

        if ( event.relatedTarget.classList.contains('sub-menu') ) {
            return false;
        }

        menuGroup.classList.remove('open');
        const openClasses = menuGroup.querySelectorAll('.open');
        [...openClasses].forEach( openItem => {
            openItem.classList.remove('open');
        });
    }

    function resetSubMenu(event) {
        if ( window.outerWidth < 1000 || window.innerWidth < 1000 ) {
            return false;
        }
        
        const parentLink = menuGroup.querySelector(`.menu-item-${event.target.classList[3].split('sub-menu-')[1]}`);
        if ( event.relatedTarget !== parentLink ) {

            menuGroup.classList.remove('open');
            const openClasses = menuGroup.querySelectorAll('.open');
            [...openClasses].forEach( openItem => {
                openItem.classList.remove('open');
            });
        }
    }

    function openSubMenu(menuItem, subMenu) {
        menuItem.classList.add('open');
        menuGroup.classList.add('open');
        subMenuGroup.classList.add('open');
        subMenu.classList.add('open');
        subMenu.addEventListener( 'mouseleave', resetSubMenu ); 
    }
    
    function closeSubMenu(menuItem, subMenu) {
        menuItem.classList.remove('open');
        menuGroup.classList.remove('open');
        subMenuGroup.classList.remove('open');
        subMenu.classList.remove('open');
    }
}